import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { ComunicadosBenef } from "../interfaces/entities/ComunicadosBenef";
import { MensagemNaoLida } from "../interfaces/entities/Notificações/MensagemNaoLida";
import { ConteudoConfirmAgendaNotific } from "../interfaces/props/ConteudoConfirmAgendaNotific";

export const getComunicadosBenef = async (codTipoComunic: string): Promise<ComunicadosBenef[] | null> => {
  try {
    const response = await apiClientes.get('/Comunicado/GetComunicadosBenef', { params: { codTipoComunic }, headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getQtdMensagemNaoLida = async (codTipoComunic: string): Promise<MensagemNaoLida[] | null> => {
  try {
    const response = await apiClientes.get('Comunicado/GetQtdMensagemNaoLida', { params: { codTipoComunic }, headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};


export const atualizarIndLidoComunica = async (idComunica: string, indLido: string): Promise<ComunicadosBenef[] | null> => {
  try {
    const response = await apiClientes.get('/Comunicado/AtualizarIndLidoComunica', { params: { idComunica, indLido }, headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const excluirComunicado = async (idComunica: string, indExclusao: string): Promise<ComunicadosBenef[] | null> => {
  try {
    const response = await apiClientes.get('/Comunicado/ExcluirComunicado', { params: { idComunica, indExclusao }, headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const cadPermissaoDefault = async (): Promise<ComunicadosBenef[] | null> => {
  try {
    const response = await apiClientes.post('Permissoes/CadPermissaoDefault', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getConteudoConfirmAgendaNotific = async (idAgenda: number, tipoNotificacao: string): Promise<ConteudoConfirmAgendaNotific | null> => {
  try {
    const response = await apiClientes.get('Agenda/GetConteudoConfirmAgendaNotific', { params: { idAgenda, tipoNotificacao }, headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa
  } catch (error) {
    console.log({ error });
    return null;
  }
};